export default __webpack_public_path__ + "static/media/EG_ReSynth-1.e88ece45.wav";